module.exports = __webpack_public_path__ + "img/mu-three.c3d9badf.jpg";